module.exports = __webpack_public_path__ + "img/bg-order.c6ebb5e0.png";